module.exports = __webpack_public_path__ + "static/img/应用场景2-高精度定位.896f21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-3/应用场景2-高精度定位.png
// module id = FTfy
// module chunks = 0